









import {Component, Prop, Vue} from "vue-property-decorator";
import {Agent} from "@/models/Agent";
import {literal} from "@/components/filters/Literal";

@Component({
  filters: {
    literal
  }
})
export default class AgentAvatar extends Vue {
  @Prop() readonly value!: Agent;
  @Prop({default: "red"}) readonly color!: string;
}
